const SoundManagerEvent = {};

SoundManagerEvent.AUDIO_PAUSED = "AUDIO_PAUSED";
SoundManagerEvent.AUDIO_CUE_CHANGED = "AUDIO_CUE_CHANGED";

export default SoundManagerEvent;